import { Settings } from "lucide-react";
import { useSettingsDialog } from "@/components/settings/settings-provider";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export function SettingsButton({ className }: { className?: string }) {
  const { open } = useSettingsDialog();
  return (
    <Button
      variant="ghost"
      size="icon"
      className={cn("size-8", className)}
      onClick={open}
      aria-label="Settings"
      title="Settings"
    >
      <Settings />
    </Button>
  );
}
